// MAINTENANCE: Delete this entire file if it is not needed when maintenance is complete
import { Alert, AlertTitle, Box } from '@mui/material'
import { t } from 'i18next'
import moment from 'moment-timezone'
import {
	MAINTENANCE_END,
	MAINTENANCE_START,
	TIMEZONE,
	getExpectedCompletionText,
	getMaintenanceWindowText
} from './config'

const sx = {
	alert: {
		marginTop: (theme) => theme.spacing(2.5),
		marginBottom: (theme) => theme.spacing(2.5),
		textAlign: 'left'
	}
}

const MaintenanceAlert = () => {
	const now = moment().tz(TIMEZONE)

	// Phase 1: Before maintenance (upcoming)
	if (now.isBefore(MAINTENANCE_START)) {
		return (
			<Box sx={sx.alert}>
				<Alert severity="warning">
					<AlertTitle>{t('app:Maintenance.upcoming.title')}</AlertTitle>
					{t('app:Maintenance.upcoming.message')}
					<br />
					<br />
					<strong>{getMaintenanceWindowText()}</strong>
				</Alert>
			</Box>
		)
	}

	// Phase 2: During maintenance
	else if (now.isBefore(MAINTENANCE_END)) {
		return (
			<Box sx={sx.alert}>
				<Alert severity="error">
					<AlertTitle>{t('app:Maintenance.during.title')}</AlertTitle>
					{t('app:Maintenance.during.message')}
					<br />
					<br />
					<strong>{getExpectedCompletionText()}</strong>
				</Alert>
			</Box>
		)
	}

	// Phase 3: After maintenance (hide alert)
	return null
}

export default MaintenanceAlert
